import { createPortal } from "react-dom";
import PatientForm from "./PatientForm";
import Button from "../ui/Button";

const portalTarget = typeof document !== "undefined" ? document.body : null;

export default function PatientFormModal({ patient, initialData, onSave, onClose }) {
  if (!portalTarget) return null;

  const resolvedPatient = patient || initialData || null;
  const isEditing = Boolean(resolvedPatient?.id);

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget && onClose) {
      onClose();
    }
  };

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-2"
      onClick={handleBackdropClick}
      role="presentation"
    >
      <div
        className="bg-white rounded-2xl shadow-xl w-full max-w-lg mx-2"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="font-semibold text-lg">
            {isEditing ? "Editează pacient" : "Adaugă pacient"}
          </h3>
          <Button variant="secondary" size="sm" onClick={onClose}>
            ✕
          </Button>
        </div>

        <PatientForm
          initialData={resolvedPatient || {}}
          onSuccess={(savedPatient) => {
            if (onSave) onSave(savedPatient);
            onClose();
          }}
          onCancel={onClose}
        />
      </div>
    </div>,
    portalTarget
  );
}
